<template>
  <v-layout>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <InputForm title="Business Trip Imposition" :deletable="deletable" @close="close" @delete="_delete"
                     @save="save"
                     v-if="loaded">
            <v-container grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 lg2>
                  <v-text-field label="Name"
                                required
                                v-model="item.impositionName"
                                :rules="rules.impositionName"
                                @input="change"/>
                </v-flex>
                <v-flex xs12 lg4>
                  <v-select :items="types" v-model="item.impositionType" @input="change" label="Type"
                            item-value="impositionType" item-text="impositionType" :rules="rules.impositionType" />
                </v-flex>
                <v-flex xs12 lg4>
                  <v-select :items="organizations" v-model="item.organization.id" @input="change" label="Organization"
                            item-value="orgId" item-text="orgName" :rules="rules.organization" />
                </v-flex>
                <v-flex xs12 lg2>
                  <v-switch label="Active" v-model="item.activation" required @change="change"/>
                </v-flex>
                <v-flex xs12 lg12>
                  <v-text-field multi-line rows="2" label="Remark" v-model="item.remark" @input="change"/>
                </v-flex>
              </v-layout>
            </v-container>
          </InputForm>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Promise from 'promise-polyfill'
import InputForm from '@/components/InputForm'
import Vuex from 'vuex'

const btImpositionStore = Vuex.createNamespacedHelpers('BusinessTripImposition')
const orgStore = Vuex.createNamespacedHelpers('Organization')

export default {
  name: 'business-trip-imposition-form',
  props: {
    deletable: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    InputForm
  },
  data () {
    return {
      item: this.value,
      loaded: false,
      rules: {
        impositionName: [
          v => !!v || 'Name is required',
          v => (typeof v === 'string' && v.length <= 100) || 'Name maximum 100 characters'
        ],
        impositionType: [
          v => !!v || 'Type is required',
          v => this.types.map(x => x.impositionType).includes(v) || 'Unknown type'
        ],
        organization: [
          v => !!v || 'Organization is required',
          v => this.organizations.map(x => x.orgId).includes(v) || 'Unknown Organization'
        ]
      }
    }
  },
  computed: {
    ...btImpositionStore.mapState({
      types: 'types'
    }),
    ...orgStore.mapState({
      organizations: 'items'
    })
  },
  methods: {
    ...btImpositionStore.mapActions({
      typeList: 'typeList'
    }),
    ...orgStore.mapActions({
      orgList: 'list'
    }),
    loadResource (StoreAction) {
      const self = this
      return new Promise((resolve, reject) => {
        StoreAction({vueinstance: self})
          .then(res => resolve(res))
          .catch(err => reject(err))
      })
    },
    loadData () {
      const self = this
      Promise.all([self.loadResource(self.typeList), self.loadResource(self.orgList)])
        .then(res => {
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    close () {
      this.$emit('close')
    },
    _delete () {
      this.$emit('delete')
    },
    save () {
      this.$emit('save')
    },
    change () {
      this.$emit('input', this.item)
    }
  },
  mounted () {
    this.loadData()
    this.$store.dispatch('setTitle', {title: 'Business Trip Imposition Detail'})
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/master/BusinessTripImpositionForm.vue